export default "/images/vendor/flag-icon-css/flags/4x3/cy.svg?c956003b42baa905013c4a8afc097ccd";